import React, { PureComponent } from 'react'
import noop from 'lodash/noop'
import BillingAddress from '../../common/BillingAddress'
import NewECheckEUDD from '../NewECheckEUDD'
import { newECPFormType } from '../types'

class NewECheckEUDDForm extends PureComponent {
  static propTypes = newECPFormType

  submitBillingAddress = noop

  submitNewECheckEUDD = noop

  constructor(props) {
    super(props)
    this.state = {
      billingInfo: {
        address: {},
      },
      newECheckEUDDInfo: {},
    }
  }

  componentDidMount() {
    const { submitTrigger } = this.props
    submitTrigger(this.submitBoth)
  }

  submitBoth = () => {
    this.setState({
      billingSubmitSuccess: false,
      newECheckEUDDSubmitSuccess: false,
    }, () => {
      this.submitBillingAddress()
      this.submitNewECheckEUDD()
    })
  }

  getBillingAddressCallBack = values => {
    this.setState({
      billingInfo: values,
      billingSubmitSuccess: true,
    }, () => {
      this.outputParameters()
    })
  }

  getNewECheckEUDDCallback = values => {
    this.setState({
      newECheckEUDDInfo: values,
      newECheckEUDDSubmitSuccess: true,
    }, () => {
      this.outputParameters()
    })
  }

  outputParameters = () => {
    const { getNewECheckEUDDFormCallback } = this.props
    const {
      billingInfo,
      newECheckEUDDInfo,
      newECheckEUDDSubmitSuccess,
      billingSubmitSuccess,
    } = this.state
    const params = { ...newECheckEUDDInfo, ...billingInfo }
    if (newECheckEUDDSubmitSuccess && billingSubmitSuccess && params.errorCode !== 'INVALID_PARAMS' && params.errorCode !== 'BILLINGADDRESS_INVALID_PARAMS') {
      getNewECheckEUDDFormCallback(params)
    }
  }

  render() {
    const { billingInfo: { address } } = this.state
    return (
      <div className="checkout-payments checkout__newecheckeudd__form">
        <NewECheckEUDD
          getNewECheckEUDDCallback={this.getNewECheckEUDDCallback}
          address={address}
          {...this.props}
          submitTrigger={submitNewECheckEUDD22 => {
            this.submitNewECheckEUDD = submitNewECheckEUDD22
          }}
        />
        <BillingAddress
          getBillingAddressCallBack={this.getBillingAddressCallBack}
          submitTrigger={submitBillingAddress => {
            this.submitBillingAddress = submitBillingAddress
          }}
        />
      </div>
    )
  }
}

export default NewECheckEUDDForm
